/**
 * Created by mukund on 5/17/16.
 */

'use strict';

angular.module('mediacloudApp')
    .factory('SearchService', function($resource) {
        return {
            SearchAssets: $resource('api/search/assets'),
            SearchCollections: $resource('api/search/collections'),
            searchForCollections: function(args, callback){
                var cb = callback || angular.noop,
                    resource = $resource('api/search/collections');

                return resource.get({ query: args.query, sitewide: args.sitewide, limit: args.limit, offset: args.offset, type: args.type, rw: args.rw },
                    function(response){
                        return cb(response);
                    }, function(err){
                        return cb(err);
                    }).$promise;
            }
        };
    });
